/* ------------------------------------------ GRYFF PRODUCT SELECTOR - CHRIS 18.08.2016 ----------------------------------------- */
import HELPER from '@/app/utils/HELPER';
import api from '@/app/endpoints.js';
import { GET } from '@/app/api';
import { base } from '@/app/editor/sidebar/constant';
import { app } from '@/store';
import {getGlobalVariable} from "@/app/editor/config/globalVariable";
import {changeProductTitlePreview, getProductPreview, getDefaultImage} from "@/app/utils/assignedProductHelper";
import { PRODUCT_ASSIGNMENT_EVENT } from '@/app/editor/config/constants/trackEventIds';

(function (jQuery) {
  jQuery.gfProductSelector = function (element, options) {
    const defaults = {
      detectChange: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    let $previewButton;
    const $btnPickedAProduct = jQuery(
      '<a id="gf-pick-product" class="button" href="#">Pick a Product</a>',
    );
    const toolTipMessage = 'Refresh Product Status';
    const _mdProductSelector = '<div id="md-product-selector"></div>';
    const _content =
      '<div class="gfPS_search"> <svg class="need_a_name" height="16px" viewbox="0 0 16 16"><path d="M6.57,9.66c-1.68,0-3.05-1.37-3.05-3.06s1.37-3.06,3.05-3.06S9.62,4.9,9.62,6.59S8.26,9.66,6.57,9.66z M14,12.92l-3.68-3.7c0.52-0.75,0.83-1.65,0.83-2.63C11.15,4.06,9.1,2,6.57,2S2,4.06,2,6.59s2.05,4.59,4.57,4.59c1,0,1.92-0.33,2.68-0.88L12.92,14L14,12.92z" /></svg> <input type="text" id="search-product" name="search-product" value="" placeholder="Search products" /> </div> <div class="gfPS_body"> <div class="product-list"> <p class="text-center"></p> </div> <div class="search_notfound"> <span class="gfPS_icon_notfound"></span> <span class="text">No Products Found</span> </div> </div>';
    const $elIconRefresh = '<span class="icon icon-refresh"></span>';
    const $elIconLoading = '<span class="snack-loading"><span class="icon icon-loading"></span>';

    let _productData;
    let _pid;
    const $activeModal = jQuery(_mdProductSelector);
    let $productList;

    /* Editor */
    const $gfLeftSideBar = getGlobalVariable('gfLeftSideBar');
    const $divTopBar = getGlobalVariable('divTopBar');
    const $divContentHidden = getGlobalVariable('divContentHidden');

    /* Iframe */
    const $gfFrame = getGlobalVariable('gfFrame');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      // Trim title ngay khi render value cho input
      $element.attr('value', $element.val());
      $element.gfInputField({textarea: true, disabled: true});

      const $pid = $element.parents('.columns').siblings().find('#pid');
      $pid.on('value-change', function () {
        $pid.trigger('input-change');
      });

      _pid = $pid && $pid.length ? $pid.val() : '';

      this.appendUIProductPicker();
      this.applyEvents();
      this.setProductStatus();
    };

    this.appendUIProductPicker = function() {
      let dataDefaultTitle = '';
      let dataDefaultImage = '/editor/static/icons/assign-product-no-pselected.svg';
      const $gfInputField = $element.next('.gfInputField');
      const elementId = $element.attr('id');
      const $dropDownSelect = $element.closest('.gfSGSettings').find('.gfDropDown').find('.gfDropDownSelect');
      const $gfDesc = $dropDownSelect.find('.gfDesc');
      const $dropdownBody = $dropDownSelect.find('.gfDropDownBody');
      // Xóa để giảm padding theo design mới của assignment
      $gfDesc.remove();
      $dropdownBody.attr('data-module', 'assign-product-dropdown');
      if(elementId === 'assigned-product') {
        // Append change preview button
        $previewButton = this.getBtnPreview();
        $previewButton.appendTo($gfInputField);
        dataDefaultTitle = 'No product assigned'; 
      } else {
        // Append pick a product button
        $btnPickedAProduct.appendTo($gfInputField);
        dataDefaultTitle = 'No product selected';
      }
      const isProductNotFound = app.$store.getters['page/GET_IS_PRODUCT_NOT_FOUND'];
      if (isProductNotFound) {
        dataDefaultTitle = "Product Not Found";
        dataDefaultImage = '/editor/static/icons/assign-product-no-pselected.svg';
      }
      const $inputFieldBox = $gfInputField.find('.gfInputFieldBox');
      $inputFieldBox.find('textarea').addClass("!hidden");
      $gfInputField.attr("data-module", elementId)
      this.addProductTitle($gfInputField, dataDefaultTitle);
      this.addProductImageSelected($gfInputField, dataDefaultImage);
      this.addCustomAttrForStyle($gfInputField);
    }

    this.getBtnPreview = function() {
      const productPicked = getProductPreview();
      let text = '';
      let dataText = '';
      if(productPicked === 'auto') {
        text = 'Assign product';
        dataText = 'assign-product';
      } else {
        text = 'Change preview';
        dataText = 'change-preview';
      }
      return jQuery(
        `<a id="gf-change-preview" data-text="${dataText}" class="button" href="#">${text}</a>`,
      );
    }



    this.addProductImageSelected = function($gfInputField, dataDefaultImage) {
      const noImage = getDefaultImage();
      $gfInputField.find('.gfInputFieldBox').prepend(`<div class='gfProductThumb'><img alt='pImage' onerror="if (this.src !== '${noImage}') this.src = '${noImage}';" src='${dataDefaultImage}'/></div>`);
    }

    this.addProductTitle = function($gfInputField, dataDefaultTitle) {
      $gfInputField.find('.gfInputFieldBox').prepend(`<div class='gfProductTitle text-left text-xs leading-[14px] ml-[8px] text-dark-mode-high-contrast font-normal'>${dataDefaultTitle}</div>`);
    }

    this.addCustomAttrForStyle = function($gfInputField) {
      $gfInputField.attr('data-module', 'assign-product');
      // Remove div margin
      $gfInputField.find('.gfDesc').remove();
    }

    this.hideGfTooltipNew = function () {
      const $el = document.getElementById('gfTooltipsNew').getElementsByClassName('gfTooltipsItem');
      if ($el && $el.length) {
        $el[0].style.display = 'none';
      }
    };

    this.setProductStatus = function () {
      const product = HELPER.searchProductInList(_pid);
      if (!product || (product && _pid == 'auto')) {
        return;
      }
      const status = product.status;
      _this.applyStatusSidebarSettings(status);
      _this.addClassInputByStatus(status);
    };

    this.isLatestProductType = function() {
      const fields = _this.getSettingCurrentTarget();
      const fieldSize = fields.length;
      for(let i = 0; i < fieldSize; i++) {
        if(fields[i].id === 'product'){
          return (fields[i].items[0].default_value === 'latest-product');
        }
      }
    }

    this.refreshPreviewSideBar = function(productId) {
      const product = HELPER.searchProductInList(productId);
      if(product && product.id) {
        _this.changePreviewSidebarWithAssignedProduct(product);
      } else {
        let product = null;
        let intervalId = null;
        let varCounter = 0;
        const varName = function () {
          // Chạy lại nhỏ hơn 10 lần và $pSelectorData vẫn đang chưa có giá trị
          if (varCounter <= 10 && !product) {
            varCounter++;
            product = HELPER.searchProductInList(productId);
            if (product && product.id) {
              _this.changePreviewSidebarWithAssignedProduct(product);
            }
          } else {
            clearInterval(intervalId);
          }
        };
        intervalId = setInterval(varName, 100);
      }
    }

    this.renderLoadingSkeleton = function(isloading) {
      const $gfInputFieldBox = $element.closest('.gfSGSettings').find('.gfInputField .gfInputFieldBox');
      if(isloading) {
        $gfInputFieldBox.find('.gfProductThumb, .gfProductTitle').hide();
        $gfInputFieldBox.prepend(`
          <div class="skeleton-text__container">
            <div class="skeleton-text"></div>
            <div class="skeleton-text skeleton-text__lg"></div>
          </div>
        `).prepend('<div class="skeleton"></div>');
      } else {
        $gfInputFieldBox.find('.gfProductThumb, .gfProductTitle').show();
        $gfInputFieldBox.find('.skeleton, .skeleton-text__container').remove();
      }
    }

    this.changePreviewSidebarWithAssignedProduct = function(product) {
      const productTitle = product.title;
      const productImage = product.image ? product.image.src : getDefaultImage();
      const pSmallImage = HELPER.getImageSmall(productImage, {
        width: 100,
        height: 100,
      });
      const $inputProductTitle = $gfLeftSideBar.find('#md-settings').find('#assigned-product');
      _this.updateProductImageSelected(pSmallImage);
      changeProductTitlePreview($inputProductTitle, productTitle);
    }

    this.applyEvents = function () {
      const elementId = $element.attr('id');
      const { type, g_id } = app.$store.state['app']['pageInfo']['page'];
      // Kiểu assigned
      if(elementId === 'assigned-product') {
        $previewButton.off().on('click', function () {
          setTimeout(() => {
            const totalAssigned = app.$store.state['page']['assignedProduct']['list'];
            app.$store.dispatch('common/trackEvent', {
              eventId: PRODUCT_ASSIGNMENT_EVENT.CLICK_ASSIGN_BUTTON_SIDEBAR,
              properties: {
                template_page_id: g_id,
                product_element_type: 'dynamic',
                button_state: totalAssigned.length > 0 ? 'assigned' : 'pre-assigned',
              },
            });
            // Nếu kiểu của button là assign-product thì sẽ open model để assign
            if($(this).attr('data-text') === 'assign-product') {
              app.$store.commit('page/UPDATE_IS_ASSIGN_PRODUCT_MODEL', true);
            } else {
              // Mở popup để change preview
              const popupActive = app.$store.getters['page/GET_POPUP_ASSIGNED_PRODUCT_ACTIVE'];
              let value = !popupActive;
              app.$store.commit('page/SET_POPUP_ASSIGNED_PRODUCT_ACTIVE', value);
              app.$store.commit('iframe/TOGGLE_OVERLAY', value);
            }
          },0);
        });
      } else { // Kiểu manual select
        $btnPickedAProduct.off().on('click', function () {
          app.$store.dispatch('common/trackEvent', {
            eventId: PRODUCT_ASSIGNMENT_EVENT.CLICK_ASSIGN_BUTTON_SIDEBAR,
            properties: {
              template_page_id: g_id,
              product_element_type: 'static',
              button_state: 'static',
            },
          });
          app.$store.commit(`productPicker/SET_SELECTOR_ELEMENT`, $element);
          app.$store.commit(`productPicker/SET_IS_OPEN_POPUP`, true);
        });
      }

      $element.off('mousedown').on('mousedown', function () {
        $btnPickedAProduct.trigger('click');
        return false;
      });
      return false;
    };

    this.applyStatusSidebarSettings = function (status) {
      const $gfProductStatus = $element.closest('.gfSGSettings').find('.gf-product-status');
      if (!status || ['active'].includes(status)) {
        $gfProductStatus.html('');
        $gfProductStatus.removeClass('active archived');
        return;
      }
      $gfProductStatus.addClass('active');
      $gfProductStatus.removeClass('archived');
      if (status === 'archived') {
        $gfProductStatus.addClass(status);
      }
      status = HELPER.capitalizeFirstLetter(status);
      $gfProductStatus.html(status);
    };

    this.addClassInputByStatus = function (status) {
      const $gfInputFieldBox = $element.closest('.gfSGSettings').find('.gfInputField .gfInputFieldBox input');
      $gfInputFieldBox.removeClass('has-status');
      if (status !== 'active') {
        $gfInputFieldBox.addClass('has-status');
      }
    };

    this.showProductSelector = function () {
      const crEditID = $gfLeftSideBar.find('#md-settings').data('edittingID');
      if (crEditID.indexOf('-child') !== -1) {
        HELPER.showNotify("Can't change product", 'error');
        return false;
      }
      $activeModal.appendTo($divContentHidden);

      $activeModal.gfModalNew({
        title: 'Select a product',
        header: 'productSelector',
        footer: '',
        background: '#F3F5F9',
        width: 580,
        height: 613,
        left: $gfLeftSideBar.children().innerWidth(),
        top: $divTopBar.innerHeight(),
        loading: true,
        onContent: function ($content) {
          $content.html(_content);
        },
      });

      $activeModal.data('gfmodalnew').onShow();

      // Click btn Cancel
      $activeModal
        .find('.gfPS_footer .btnCancel')
        .off('click')
        .on('click', function () {
          $activeModal.remove();
        });

      // Click btn Reload
      const $actionReload = $activeModal.find('.gf_modal-header .gf_modal-right .gf_modal-reload');
      $actionReload.off('click').on('click', function () {
        $activeModal.find('#search-product').val('');
        $activeModal.find('.search_notfound').removeClass('active');
        _this.getProducts();
      });
      $actionReload.gfTooltipsNew({
        postion: 'bottom',
        desc: toolTipMessage,
        timeIn: 0,
        timeOut: 0,
      });

      // Add notice
      _this.renderNotice();

      // update stuffs
      _this.getProducts();

      $productList = $activeModal.find('.product-list');
      let delaySearch;
      let delayAjaxSearch;
      $activeModal
        .find('#search-product')
        .off('keyup paste')
        .on('keyup paste', function () {
          clearTimeout(delaySearch);
          clearTimeout(delayAjaxSearch);
          let count = 0;
          const input = jQuery(this).val().trim().toLowerCase();
          $activeModal.find('.search_notfound').removeClass('active');

          delaySearch = setTimeout(function () {
            if (input !== '') {
              $productList.find('ul li').hide();
              const $product = $productList.find('ul li');
              for (let i = 0; i < $product.length; i++) {
                const title = $($product[i]).find('span').text().toLowerCase();
                if (title.indexOf(input) >= 0) {
                  $($product[i]).show();
                  count++;
                }
              }
            } else {
              $productList.find('ul li').show();
            }
          }, 10);

          delayAjaxSearch = setTimeout(function () {
            if (input !== '') {
              _this.searchProducts(input, count);
            }
          }, 500);
        });

      return false;
    };

    this.renderNotice = function () {
      const html = `<div class="gf-product-selector-notice"><div class="icon icon-warn-circle"></div><div class="gf-product-selector-notice--desc">"Draft" and "Archived" products can't be viewed on live page. You can change products status in Shopify.</div></div>`;
      const notice = $activeModal.find('.gfPS_body .gf-product-selector-notice');
      if (!notice || !notice.length) {
        $activeModal.find('.gfPS_body').prepend(html);
      }
    };

    this.setClassScroll = function () {
      const $productListItems = $activeModal.find('.product-list ul');
      $productListItems.removeClass('has-scroll');
      if ($productListItems.height() > 443) {
        $productListItems.addClass('has-scroll');
      }
    };

    this.getProducts = function () {
      $productList = $activeModal.find('.product-list');
      const $gfModalReload = $activeModal.find('.gf_modal-header .gf_modal-right .gf_modal-reload');
      $gfModalReload.attr('disabled', true);
      $gfModalReload.html($elIconLoading);
      _this.hideGfTooltipNew();
      HELPER.getNewestProducts(function (jsonData) {
        if (jsonData.products && jsonData.products.length > 0) {
          HELPER.handleProductNotFound(false);
          const _products = jsonData['products'];
          _productData = jsonData['products'];
          let html = '';
          html = _this.renderProducts(_products, html);
          html = '<ul>' + html + '</ul>';

          $productList.html(html).addClass('optiscroll');
          _this.setClassScroll();
          $activeModal.data('gfmodalnew').offLoading();

          $gfModalReload.removeAttr('disabled');
          $gfModalReload.html($elIconRefresh);
          // Active;
          _this.bindProductEvents();
        } else {
          HELPER.handleProductNotFound(true);
        }
      });
    };

    this.renderProducts = function (products, html) {
      for (let i = 0; i < products.length; i++) {
        html +=
          '<li data-pid="' +
          products[i].id +
          '" data-pStatus="' +
          products[i].status +
          '" data-pHandle="' +
          products[i].handle +
          '" data-pTitle="' +
          products[i].title +
          '">';
        if (products[i].image && products[i].image.src) {
          // Src image small
          const smallSrc = HELPER.getImageSmall(products[i].image.src, {
            width: 40,
            height: 40,
          });
          html += '<div class="gfPS_thumbnail">';
          html += '<img src="' + smallSrc + '" />';
          html += '</div>';
        } else {
          html += '<div class="gfPS_thumbnail">';
          html += '<div class="gfPS_icon_thumbnail"></div>';
          html += '</div>';
        }

        html += "<span class='gfPS_title'>" + products[i].title + '</span>';

        const status = this.renderStatusProduct(products[i].status);
        if (status) {
          html += "<div class='gfPS_status'><span class='tag " + status.class + "'>" + status.title + '</span><div>';
        }

        html += '</li>';
      }
      return html;
    };

    this.renderStatusProduct = function (status) {
      if (!status || ['active'].includes(status)) {
        return '';
      }
      const title = HELPER.capitalizeFirstLetter(status);
      let className = '';
      if (status === 'archived') {
        className = 'tag-archived';
      }
      return {
        class: className,
        title: title,
      };
    };

    this.bindProductEvents = function () {
      $productList
        .find('ul li')
        .off('click')
        .on('click', function () {
          const item = jQuery(this);
          const productTitle = item.attr("data-pTitle");
          const productId = item.attr("data-pid");
          const productHandle = item.attr("data-pHandle");
          const productStatus = item.attr("data-pStatus");
          let productImage = item.find("img").attr("src") ?? getDefaultImage();
          const productAttr =  {title: productTitle, image: productImage, id: productId, handle: productHandle};

          // set product id
          _pid = productId;

          _this.applyStatusSidebarSettings(productStatus);
          _this.addClassInputByStatus(productStatus);

          setTimeout(function () {
              _this.updateElementInfo(productAttr);
          }, 100);

          _this.updateDataSettings(productAttr);

          $activeModal.remove();
          _this.settings.detectChange();
          return false;
        });
    };

    this.updateElementInfo = function(productAttr) {
      const {title, image, id, handle} = productAttr;
      changeProductTitlePreview($element, title);
      $element.attr('data-value', title);
      $element.attr('data-id', id);

      // Fix lại đường dẫn tới pHandle
      const $pHandle = $element.parents('.columns').siblings().find('#pHandle');
      $pHandle.attr('default-value', handle);
      $pHandle.attr('value', handle).val(handle);

      // Fix lại đường dẫn tới pid
      const $pid = $element.parents('.columns').siblings().find('#pid');
      $pid.attr('default-value', id);
      $pid.attr('value', id).val(id).trigger('input-change').trigger('history-change');

      _this.updateProductImageSelected(image);

      // Refresh lại VariantSelector sau khi pick Product
      _this.refreshVariantSelector();
    }

    this.getSettingCurrentTarget = function() {
      const moduleId = _this.getCurrentModuleId();
      const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
      const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
      return jQuery.parseJSON($settings);
    }

    this.saveSettingCurrentTarget = function(fields) {
      const moduleId = _this.getCurrentModuleId();
      const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: keySettings,
        value: JSON.stringify(fields),
      });
    }

    this.getCurrentModuleId = function() {
      return $gfLeftSideBar.find('#md-settings').data('edittingID').replace('m-', '');
    }

    this.updateDataSettings = function(productAttr) {
      const {title, image, id, handle} = productAttr;
      let fields = _this.getSettingCurrentTarget();

      const fieldSize = fields.length;
      for (let i = 0; i < fieldSize; i++) {
        if (fields[i].name === 'product') {
          fields[i].default_value = title;
          // Update giá trị của manual select
          fields[i].items[2].default_value = title;
          fields[i].items[2].default_value_image = image;
          fields[i].items[2].default_value_id = id;
        }
        if (fields[i].name === 'pid') {
          fields[i].default_value = id;
        }
        if (fields[i].name === 'pHandle') {
          fields[i].default_value = handle;
        }
      }

     _this.saveSettingCurrentTarget(fields);
    }

    this.updateProductImageSelected = function(productImage) {
      const $gfSGSettings = $element.closest(".gfSGSettings");
      $gfSGSettings.find('.gfProductThumb').find('img').attr('src', productImage);
    }

    this.searchProducts = function (s, count) {
      const shop = $gfFrame.data('gfframe').getShopDomain();
      const data = {
        shop: shop,
        s: s,
        limit: 249,
      };
      GET(api.searchProducts().url, data)
        .then((res) => {
          const jsonData = res.data;
          if (!jQuery.isEmptyObject(jsonData)) {
            const _products = jsonData['products'];
            // Check search !== search off
            for (var i = 0; i < _productData.length; i++) {
              for (let j = 0; j < _products.length; j++) {
                if (_products[j].id == _productData[i].id) {
                  _products.splice(j, 1);
                }
              }
            }

            // push store data
            for (var i = 0; i < _products.length; i++) {
              _productData.push(_products[i]);
            }

            if (_products.length > 0) {
              let html = '';
              html = _this.renderProducts(_products, html);
              $productList.find('ul').append(html);
              _this.setClassScroll();
              _this.bindProductEvents();
            } else {
              if (count == 0) {
                // not found
                $activeModal.find('.search_notfound').addClass('active');
              }
            }
          }
        })
        .catch((err) => {
          HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
          // not found
          $activeModal.find('.search_notfound').addClass('active');
        });
      return false;
    };

    this.refreshVariantSelector = function () {
      // update variant setting in sidebar
      const $sidebarVariantSetting = jQuery('input#variant.gf-field-item');

      // Xóa các options Variant hiện tại
      if ($sidebarVariantSetting.data('gfvariantselector')) {
        const oldSelectors = $sidebarVariantSetting.siblings('div.gryff_layout-onion');
        oldSelectors.remove();

        $sidebarVariantSetting.removeData('gfvariantselector');
      }

      // Init new Variant
      $sidebarVariantSetting.gfVariantSelector({
        /**
         * gfVariantSelector.detectChange
         */
        detectChange: function () {},
      });
    };

    this.init();
  };

  jQuery.fn.gfProductSelector = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfproductselector')) {
        const plugin = new jQuery.gfProductSelector(this, options);
        jQuery(this).data('gfproductselector', plugin);
      }
    });
  };
})(jQuery);
